import { createClient, type SupabaseClient } from '@supabase/supabase-js';

// Crie3 v2 reuses v1's Supabase project (decision D7), so these point at the
// same auth/control plane v1 uses. Next inlines NEXT_PUBLIC_* at build time.
const url = process.env.NEXT_PUBLIC_SUPABASE_URL ?? '';
const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '';

// When both are set the web runs in hosted, signed-in mode; otherwise it stays
// the open local/desktop app. Everything downstream (the fetch interceptor, the
// login gate) branches on this so an unconfigured build behaves exactly as the
// upstream app did.
export const supabaseConfigured = Boolean(url && key);

// Construct only when configured — createClient throws on an empty url/key, and
// this module is imported eagerly by the auth gate, so an unconfigured build
// would otherwise crash the whole app at import time rather than just skip the
// login surface. When unconfigured, `supabase` is never touched.
export const supabase: SupabaseClient = supabaseConfigured
  ? createClient(url, key, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : (null as unknown as SupabaseClient);
